import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'ngx-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent implements OnInit {
  @Input() pageUrl: string;
  @Input() label: string;

  isNative: boolean = Capacitor.isNativePlatform();
  constructor(private router: Router) {}

  ngOnInit(): void {}

  backTo() {
    this.router.navigate([this.pageUrl]);
  }
}
